import {call, put, takeLatest} from "redux-saga/effects";
import {fetchAuth, fetchAuthDone, fetchAuthFail,fetchModules,fetchModulesDone,fetchModulesFail,fetchGetProfile, fetchGetProfileDone, fetchGetProfileFail ,getUserProfileActionReset,fetchRestore,fetchRestoreDone,fetchRestoreFail ,setRegisterData,setEmbedData, fetchRegister, fetchRegisterDone, fetchRegisterFail, getSpecialistsDone, getSpecialistsFail, getSpecialists, fetchReviewsListDone, fetchReviewsListFail, fetchReviewsListAction, fetchResendCodeAction, fetchResendCodeDone, fetchResendCodeFail, fetchConfirmResetPasswordDone, setRestoreData, fetchConfirmResetPasswordFail, fetchConfirmResetPasswordAction, fetchConfirmPasswordDone, fetchConfirmPasswordFail, fetchConfirmPasswordAction } from "./actions";
import {PayloadAction} from "@reduxjs/toolkit";
import {setTokenCookie, setRefreshTokenCookie, setScreeningCookie} from "../../../context";
import {apiAuth, apiRegister, apiRestore, apiGetProfile, apiGetModules, apiGetSpecialists, apiGetReviewsList, apiResendCode, apiConfirmResetPassword, apiConfirmPassword} from "./api";

function* authFlow({ payload }: PayloadAction<any>): any {
  try {

    const data = yield call(apiAuth, payload);

    if (data.status === "error") {
      yield put(fetchAuthFail(data));
    } else {
      yield put(fetchAuthDone(data));
      yield call(setScreeningCookie, data.modules?.includes("screening"));
      yield call(setTokenCookie, data.access_token); 
      yield call(setRefreshTokenCookie, data.refresh_token); 
    }
  } catch (e) {
    yield put(fetchAuthFail(e.response.data));
  }
}

function* registerFlow({ payload }: PayloadAction<any>): any {
  try {

    const data = yield call(apiRegister, payload);

    if (data.status === "error") {
      yield put(fetchRegisterFail());
      
    } else {
      yield put(fetchRegisterDone(payload));
    }
  } catch (e) {
    yield put(fetchRegisterFail(e.response.data));
  }
}

function* modulesFlow({payload}:PayloadAction<any>): any {
    try {
      const data = yield call(apiGetModules, payload);

      if (data) {
        yield put(fetchModulesDone(data))
        yield call(setScreeningCookie, data.modules?.includes("screening"));
      }
  
    } catch (e) {
      yield put(fetchModulesFail())
    }
  }


function* profileGetFlow({payload}:any): any {
  try {

    const data = yield call(apiGetProfile);

    if (data) {
      if(payload.onRegionNull){
        if(!data?.profile.region_id){
          payload.onRegionNull()
        }
      }

      yield put(fetchGetProfileDone(data?.profile))
    }

  } catch (e) {
    yield put(fetchGetProfileFail())
  }
}

function* restoreFlow({ payload }: PayloadAction<any>): any {
  try {

    const data = yield call(apiRestore, payload);

    if (data.status === "error") {
      yield put(fetchRestoreFail());
      
    } else {
      yield put(fetchRestoreDone({
        request: payload,
        response: data,
      }));
    }
  } catch (e) {
    yield put(fetchRestoreFail(e.response.data));
  }
}

function* logoutFlow(): any {
  yield put(getUserProfileActionReset());
}

function* getSpecialistsFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiGetSpecialists, payload);

    const list = Array.isArray(response)
      ? response
      : Array.isArray(response?.data)
        ? response.data
        : [];

    const filtered = list.filter((item: any) => item.id !== 6);

    yield put(getSpecialistsDone(filtered));
  } catch (e) {
    yield put(getSpecialistsFail());
  }
}

function* reviewsListFlow(): any {
  try {
    const response = yield call(apiGetReviewsList);
    yield put(fetchReviewsListDone(response));
  } catch (e) {
    yield put(fetchReviewsListFail({}));
  }
}

function* resendCodeFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiResendCode, payload);
    yield put(fetchResendCodeDone(response));
  } catch (e) {
    yield put(fetchResendCodeFail({}));
  }
}

function* confirmResetPasswordFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiConfirmResetPassword, payload);
    yield put(fetchConfirmResetPasswordDone(response));
    yield put(setRestoreData());
  } catch (e: any) {
    yield put(fetchConfirmResetPasswordFail(e?.response?.data || {}));
  }
}

function* confirmPasswordFlow({ payload }: PayloadAction<any>): any {
  try {
    const response = yield call(apiConfirmPassword, payload);
    yield put(fetchConfirmPasswordDone(response));
  } catch (e: any) {
    yield put(fetchConfirmPasswordFail(e?.response?.data || {}));
  }
}

export default function* profileSaga() {
  yield takeLatest(fetchAuth, authFlow);
  yield takeLatest(fetchRegister, registerFlow);
  yield takeLatest(fetchRestore, restoreFlow);
  yield takeLatest(fetchGetProfile, profileGetFlow);
  yield takeLatest(fetchModules, modulesFlow);
  yield takeLatest(getSpecialists, getSpecialistsFlow);
  yield takeLatest(fetchReviewsListAction, reviewsListFlow);
  yield takeLatest(fetchResendCodeAction, resendCodeFlow);
  yield takeLatest(fetchConfirmResetPasswordAction, confirmResetPasswordFlow);
  yield takeLatest(fetchConfirmPasswordAction, confirmPasswordFlow);
}